import { defineNuxtPlugin } from '#app'
import {
  analyticsAllowed,
  safeAnalyticsUrl,
  startPrivacy,
} from '~/privacy/consent'

export default defineNuxtPlugin(async (nuxtApp) => {
  const config = useRuntimeConfig()
  let client = null
  let initializing = false
  const pageview = () => {
    if (analyticsAllowed())
      client?.capture('$pageview', {
        current_url: safeAnalyticsUrl(location.href),
      })
  }
  const sync = async () => {
    if (!analyticsAllowed()) {
      client?.opt_out_capturing()
      return
    }
    if (client) {
      client.opt_in_capturing({ captureEventName: false })
      return
    }
    if (initializing || !config.public.posthogPublicKey) return
    initializing = true
    try {
      const { default: posthog } = await import('posthog-js')
      if (!analyticsAllowed()) return
      client = posthog.init(config.public.posthogPublicKey, {
        api_host: config.public.posthogHost,
        person_profiles: 'never',
        capture_pageview: false,
        capture_pageleave: false,
        autocapture: false,
        disable_session_recording: true,
        disable_surveys: true,
        advanced_disable_feature_flags: true,
        advanced_disable_decide: true,
        cookie_expiration: 182,
        save_referrer: false,
        save_campaign_params: false,
        mask_personal_data_properties: true,
        custom_personal_data_properties: Array.from(
          new URLSearchParams(location.search).keys(),
        ),
        before_send: (event) => {
          if (!event || !analyticsAllowed()) return null
          for (const key of Object.keys(event.properties).filter((key) =>
            /url|referrer/i.test(key),
          )) {
            if (typeof event.properties[key] === 'string')
              event.properties[key] = safeAnalyticsUrl(event.properties[key])
          }
          delete event.properties.$set
          delete event.properties.$set_once
          return event
        },
      })
      client?.register({
        environment: config.public.sentryEnvironment || 'production',
      })
      pageview()
    } finally {
      initializing = false
    }
  }
  window.addEventListener('yogen:privacy-change', () => {
    void sync()
  })
  nuxtApp.$router.afterEach(() => {
    void sync()
    pageview()
  })
  await startPrivacy()
  return { provide: { posthog: () => (analyticsAllowed() ? client : null) } }
})
